import _ from 'lodash';
import dayjs from 'dayjs';
import { TW_OCR_STATUS, sampleDocList } from '@/sampleData/aiOcrCommon';
import { $api } from '@/store/ApiClient';
import { notify } from '@/libs/notify';
import {
  RESPONSIBLE_FLG,
  PROCESS_OPERATION,
  DOCUMENT_EDIT_FLG,
  ABLE_FLG,
  CARGO_GROSS_WEIGHT_UNIT_VARIABLES,
  CARGO_GROSS_VOLUME_UNIT_VARIABLES,
  PROCESS_TYPE,
} from 'lib-tw-common';
import { downLoadTsv } from '@/utils/tsv.js';

const AI_OCR_CONFLICT_FLAGS = [
  'updateCommonItemsExclusiveFlag1',
  'updateCommonItemsEntitySpecificItemsExclusiveFlag2',
  'overwritePredecessorEntityExclusiveFlag3',
  'overwritingCommonItemsEntitySpecificItemsExclusiveFlag4',
];

export default {
  inject: {
    s: {
      from: 's',
      default: {},
    },
    hasAiOcrPermitted: {
      from: 'hasAiOcrPermitted',
      default: () => () => {},
    },
    refreshProcess: {
      from: 'refreshProcess',
      default: () => () => {}
    }
  },
  data() {
    return {
      // aiOcr用
      aiOcrLoading: { status: false, start: false, fetch: false },
      aiOcrStatusIsLoading: true,
      enableAiOcr: true,
      isShowDialogAiOcr: false,
      selectedAiOcrPayload: null,
      loadingAiOcrStatus: false,
      disabledAiOcrReading: false,
      isDirty: false,
      mappingData: null,
      mappingRes: null,
      localResData: null,
      aiOcrStatusList: [],
      sampleDocList,
      validationCheckMethod: null,
      isSaveCompletedIds: [],
      timerId: null,
      selectedTab: 'single',
      targetItems: 'goodsLine',
      ocrSupportedDocsConfig: {
        // ファイル種別をキー名として設定を持たせ、プロセス種別ごとに読み込めるようにする
        [PROCESS_TYPE.ICREQ]: {
          documentLinkInv: true,
          documentLinkBl: true,
          documentLinkPl: true,
          documentLinkPo: true,
        },
        [PROCESS_TYPE.ECREQ]: {
          documentLinkInv: true,
          documentLinkBl: true,
          documentLinkPl: true,
          documentLinkPo: true,
        },
      },
      ocrApiMapping: {
        // プロセス種別ごとのAI-OCR下書き保存(差分更新)APIのマッピング
        // PATCH側(postProcessWkDiff)はBFFが最新initialを取得し、送信したキーだけを上書きする
        [PROCESS_TYPE.ICREQ]: 'patch_/v1/request-imp-cc/{entityId}/{processId}/{processSeq}/aiOcr',
        [PROCESS_TYPE.ECREQ]: 'patch_/v1/request-ex-cc/{entityId}/{processId}/{processSeq}/aiOcr',
      },
    };
  },
  computed: {
    companyId() {
      return this.$store.state.companyId;
    },
    isArchive() {
      return this.$route.name.includes('Archive');
    },
    // Editボタンの表示可否を返却します
    // ブロックチェーン書き込み実行後・Delete後は非表示。担当者ロール以外のユーザーは非表示
    needEditButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      // To側のボールで入力項目が無ければ非表示
      // if (this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.TO && !this.hasInputItem) {
      //   return false;
      // }
      return this.s.res.tradeManagement.editAbleFlg === ABLE_FLG.TRUE;
    },
    hasActiveAiOcrDocument() {
      return this.aiOcrStatusList.length > 0;
    },
    isDocumentTypePl(){
      return this.selectedAiOcrPayload?.document.documentLinkPl === 1
    },
    isDocumentTypeBl(){
      return this.selectedAiOcrPayload?.document.documentLinkBl === 1
    },
    isDocumentTypeInv(){
      return this.selectedAiOcrPayload?.document.documentLinkInv === 1;
    },
    isDocumentTypePo() {
      return this.selectedAiOcrPayload?.document.documentLinkPo === 1;
    },
    processType() {
      return this.s.processType;
    },
  },
  methods: {
    btnPropsByAiOcrStatus(doc) {
      const base = {
        0: { type: 'primary' },
        1: { type: 'primary', plain: true },
        2: { type: 'primary', plain: true },
        4: { type: 'success' },
        5: { type: 'success' },
        91: { type: 'danger', plain: true },
        92: { type: 'danger', plain: true },
        93: { type: 'danger', plain: true },
        94: { type: 'danger', plain: true },
        99: { type: 'danger', plain: true },
      };
      const props = { ...(base[doc.aiOcrStatus] || { type: 'primary' }) };
      // ステータス5（読取結果）の場合だけ、保存済みならplainにする
      if (doc.aiOcrStatus === 4 || doc.aiOcrStatus === 5) {
        props.plain = this.isSaveCompletedIds.includes(doc.documentManageId);
      }
      return props;
    },
    btnTextByAiOcrStatus(doc) {
      const map = {
        0: 'AI-OCR: 読取開始',
        1: 'AI-OCR: 読取中',
        2: 'AI-OCR: 読取中',
        4: this.isSaveCompletedIds.includes(doc.documentManageId)
          ? 'AI-OCR: 読取結果反映済み'
          : 'AI-OCR: 読取結果',
        5: this.isSaveCompletedIds.includes(doc.documentManageId)
          ? 'AI-OCR: 読取結果反映済み'
          : 'AI-OCR: 読取結果',
        91: 'AI-OCR: エラー',
        92: 'AI-OCR: エラー',
        93: 'AI-OCR: エラー',
        94: 'AI-OCR: エラー',
        99: 'AI-OCR: エラー',
      };
      return map[doc.aiOcrStatus] || 'AI-OCR';
    },
    handleUpdateStatusBtn() {
      this.isSaveCompletedIds.length > 0
        ? this.confirmReloadMsg()
        : this.getAiOcrStatus();
    },
    confirmReloadMsg() {
      this.$store
        .dispatch(
          'SHOW_CONFIRM',
          'AI-OCRの結果反映を実施したので一度画面を更新します。よろしいですか？',
        )
        .then(() => {
          window.location.reload();
        });
    },
    async getAiOcrStatus() {
      // ステータス取得開始。初期値はtrueにしているが明示
      this.aiOcrLoading.status = true;
      // 読取開始を実行したドキュメントを初期化
      this.aiOcrStatingDocs = [];

      const documentList = [];
      this.documents.map(document => {
        documentList.push({
          documentManageId: document.documentManageId,
          // documentTrx: document.documentTrx,
        });
      });
      if (documentList.length === 0) return;

      const params = {
        lslConfig: {
          serviceCode: 'tw-pooldata-bff-api',
          apiCode: 'post_/v1/AiOcr/getAiOcrStatus',
        },
        data: {
          getTargetList: documentList,
        },
      };

      try {
        const res = await $api.request(params);
        this.aiOcrStatusList = res?.ocrStatusList;
      } catch (err) {
        this.$store.dispatch('SHOW_ALERT', err?.message);
      } finally {
        this.aiOcrLoading.status = false;
      }
    },
    isOcrSupportedDocumentType(doc){
      // documentLink*** のキーだけを抽出
      const linkKeys = Object.keys(doc).filter(k =>
        k.startsWith('documentLink'),
      );
      // 1になっているキーを抽出
      const activeLinks = linkKeys.filter(k => _.get(doc, k) === 1);
      // 条件:
      // 1. 有効Link1つだけ
      // 2. そのキーが OCR対象の種別 のみ
      return (
        activeLinks.length === 1 && this.ocrSupportedDocsConfig[this.processType]?.[activeLinks[0]]
        //['documentLinkInv', 'documentLinkBl', 'documentLinkPl'].includes(activeLinks[0])
      );
    },
    useAiOcr(target) {
      // 編集権限がないとAI-OCRボタンは出ない
      if (!this.needEditButton) return false;

      // マスタ設定でAI-OCRが利用可能でないといけない
      if (!this.hasAiOcrPermitted() || this.s.res.documents?.length === 0) {
        return false;
      } else {
        // OCRが有効な帳票のみ
        return this.isOcrSupportedDocumentType(target);
      }
    },
    hasInvalidStatus(doc) {
      const targetLabels = ['OcrPending', 'OcrProcessing'];
      const invalidStatus =
        _.map(
          _.filter(TW_OCR_STATUS, s => targetLabels.includes(s.label)),
          'code',
        ) || [];
      // BFFの返り値ををdocに含めているので、そのステータスで処理中のものはボタンをdisabledに。
      return (
        invalidStatus.includes(doc.aiOcrStatus) ||
        this.isSaveCompletedIds.includes(doc.documentManageId)
      );
    },
    handleAiOcrActions(doc) {
      if (doc.aiOcrStatus === 0) {
        this.startAiOcr(doc);
      }
      if (doc.aiOcrStatus === 4 || doc.aiOcrStatus === 5) {
        this.showDialogAiOcr(doc);
      }
      if ([91, 92, 93, 94, 99].includes(doc.aiOcrStatus)) {
        this.aiOcrShowErrorMeg(doc);
      }
    },
    startAiOcr(doc) {
      if (this.aiOcrLoading.start) {
        this.$store.dispatch(
          'SHOW_ALERT',
          '他のドキュメントがAI-OCR実行中です。少し待ってから実行ください。',
        );
      } else {
        const documentLinkCount = [
          doc.documentLinkInv,
          doc.documentLinkPl,
          doc.documentLinkBl,
          doc.documentLinkAn,
          doc.documentLinkSi,
          doc.documentLinkCo,
          doc.documentLinkOthers1,
          doc.documentLinkOthers2,
          doc.documentLinkOthers3,
          doc.documentLinkOthers4,
          doc.documentLinkOthers5,
          doc.documentLinkContract,
          doc.documentLinkDn,
          doc.documentLinkPo,
        ].filter(value => value === 1).length;

        // 2つ以上が1の場合、エラーを投げる
        if (documentLinkCount > 1) {
          this.$store.dispatch(
            'SHOW_ALERT',
            '帳票区分が複数ある場合、AI-OCRは実行できません。',
          );
          return;
        }

        this.$store
          .dispatch('SHOW_CONFIRM', 'AI-OCRでのPDFファイルの読取を開始します。')
          .then(() => {
            const profile = this.$store.state.userProfile;

            let documentTypeId = '';
            if (doc.documentLinkInv === 1) {
              documentTypeId = '1';
            }
            if (doc.documentLinkPl === 1) {
              documentTypeId = '2';
            }
            if (doc.documentLinkBl === 1) {
              documentTypeId = '3';
            }
            if (doc.documentLinkAn === 1) {
              documentTypeId = '4';
            }
            if (doc.documentLinkSi === 1) {
              documentTypeId = '5';
            }
            if (doc.documentLinkCo === 1) {
              documentTypeId = '6';
            }
            if (doc.documentLinkDn === 1) {
              documentTypeId = '8';
            }
            if (doc.documentLinkPo === 1) {
              documentTypeId = '9';
            }

            const data = {
              documentTrx: doc.documentTrx,
              documentTypeId: documentTypeId,
              documentManageId: doc.documentManageId,
              processTradingInfo: {
                tradingId: doc.tradingId,
                tradingFlowId: doc.tradingFlowId,
                entityId: doc.entityId,
                processId: doc.processId,
                processSeq: doc.processSeq,
                companyId: profile.companyId,
                requestUserId: profile.userId,
              },
            };

            const params = {
              lslConfig: {
                serviceCode: 'tw-pooldata-bff-api',
                apiCode: 'post_/v1/AiOcr',
              },
              data: _.cloneDeep(data),
            };

            try {
              this.aiOcrLoading.start = true;
              $api.request(params).then(res => {
                this.aiOcrLoading.start = false;
                notify.success({
                  title: 'AI-OCRでの読取を開始しました',
                  message:
                    '画面を更新し、AI-OCR: 結果確認ボタンより、取得状況をご確認ください。完了まで約1-2分 ほど時間がかかります。',
                });
                const aiOcrStatus = {
                  documentManageId: doc.documentManageId,
                  documentTrx: doc.documentTrx,
                  cinnamonOcrStatus: 2,
                  twOcrStatus: 2,
                };
                this.aiOcrStatusList.push(aiOcrStatus);
              });
            } catch (err) {
              this.$store.dispatch('SHOW_ALERT', err?.message);
              alert(err);
            } finally {
              this.aiOcrLoading.start = false;
            }
          });
      }
    },
    showDialogAiOcr(doc) {
      this.selectedAiOcrPayload = {
        document: doc,
        documentTrx: doc.aiOcrTrx,
        // localResDataはマウント時の固定スナップショットのため、
        // refreshProcess()で更新される s.res を基準にする（差分表示の正確化）
        detailInitialData: _.cloneDeep(this.s.res),
      };
      if (this.isDocumentTypePl) {
        this.targetItems = 'goodsLinePacking';
      } else if (this.isDocumentTypeInv) {
        this.targetItems = 'goodsLine';
      } else if (this.isDocumentTypePo) {
        this.targetItems = 'goodsLine';
      } else {
        this.targetItems = 'containerSeals';
      }
      this.isShowDialogAiOcr = true;
    },
    aiOcrShowErrorMeg(doc) {
      const message = `<div class="text-18 text-bold text-grey-600 mb-2">AI-OCR Error</div><div class="text-14 text-grey-600">error code: ${
        doc.aiOcrStatus
      }</div><div>エラーが発生しました。再度ファイルをアップロードしてお試しください。</div>`;
      this.$store.dispatch('SHOW_ALERT', message);
    },
    handleUpdateOcrData(data, res) {
      if (!_.isEqual(this.s.res, data)) {
        this.isDirty = true;
      }
      this.mappingData = data;
      this.mappingRes = res;
      // ハイライト確認用 ※デバッグ時に利用
      // this.startHighlight();
    },
    closeDialogAiOcr() {
      this.$store
        .dispatch(
          'SHOW_CONFIRM',
          this.$t('Message.CONFIRM__NAVIGATION_WITH_UNSAVED_DATA'),
        )
        .then(() => {
          this.isShowDialogAiOcr = false;
          this.selectedAiOcrPayload = null;
        });
    },
    aiOcrValidationCheck(method) {
      this.validationCheckMethod = method;
    },
    handleAiOcrChangeTab(currentTab, tableSchema) {
      this.selectedTab = currentTab;
      this.targetItems = tableSchema;
    },
    loadPickKeyByItem(targetItem){
      const goodsKey = [
        'ocrGoodsShortName',
        'ocrQuantity1',
        'ocrCountryOfOriginNames',
        'ocrGoodsRefNo1',
        // 'ocrHscode',
        'ocrUnit',
        'ocrUnitPrice',
        'ocrImCustomsCurrencies',
        'ocrAmountPerItem',
      ];
      const containerSealsKey = [
        'ocrContainerNo',
        'ocrContainerSize',
        'ocrContainerType',
        'ocrCargoGrossWeight',
        'ocrCargoGrossWeightUnit',
        'ocrCargoGrossVolume',
        'ocrCargoGrossVolumeUnit',
      ];
      const goodsLinePackingKey = [
        'ocrGoodsShortName',
        //'ocrHscode',
        'ocrGoodsRefNo1',
        'ocrPlcontainerNo',
        'ocrPlQuantity1',
        'ocrPlUnit1',
        'ocrPlPcsNumber',
        'ocrPlPcsUnit',
        'ocrPlNetTotal',
        'ocrPlGrossTotal',
        'ocrPlWeightUnit',
        'ocrPlGrossMeasurementTotal',
        'ocrPlMeasurementUnit',
      ];

      if (targetItem === 'goodsLinePacking') {
         return goodsLinePackingKey;
      } else if(targetItem === 'goodsLine') {
         return goodsKey;
      } else {
        return containerSealsKey;
      }
    },
    handleAiOcrTsvDownload() {
      if (!this.targetItems) return;

      this.$store
        .dispatch('SHOW_CONFIRM', 'TSVデータをダウンロードします')
        .then(() => {
          const copyData = _.cloneDeep(this.mappingRes) || {itemsTableData:[]};

          const pickKeys = this.loadPickKeyByItem(this.targetItems);
          const targetItems = copyData.itemsTableData.map(item => {
            const result = {};
            pickKeys.forEach(key => {
              // key が item に存在するか
              if (key in item) {
                const newKey = key.replace(/^ocr/, '');
                let val = '';
                if (key === 'ocrCargoGrossWeightUnit') {
                  const foundWeightUnit = _.find(
                    CARGO_GROSS_WEIGHT_UNIT_VARIABLES,
                    {
                      code: item[key],
                    },
                  );
                  val = foundWeightUnit?.label;
                } else if (key === 'ocrCargoGrossVolumeUnit') {
                  const foundVolumeUnit = _.find(
                    CARGO_GROSS_VOLUME_UNIT_VARIABLES,
                    {
                      code: item[key],
                    },
                  );
                  val = foundVolumeUnit?.label;
                } else {
                  val = item[key];
                }
                result[newKey] = val;
              }
            });
            return result;
          });

          // goodsItemsもしくはcontainerSealsのどちらかのみ
          copyData.itemsTableData = [...targetItems];

          const tsvText = this.buildTsvFromData(copyData);
          const timestamp = dayjs().format('YYYYMMDD_HHmmss');
          const base = _.replace(
            this.selectedAiOcrPayload?.document?.documentName,
            /\.[^/.]+$/,
            '',
          );
          const filename = `${base}_${
            this.selectedAiOcrPayload?.document?.documentTrx
          }_${timestamp}.tsv`;
          downLoadTsv(tsvText, filename);
        });
    },
    async handleSave() {
      const res = await this.validationCheckMethod();
      if (!res.ok) {
        let messages = '';
        res.result?.error.map(rst => {
          messages += rst.validMessage.message + '<br>';
        });
        this.$store.dispatch('SHOW_ALERT', messages);
        return;
      }
      this.$store
        .dispatch(
          'SHOW_CONFIRM',
          '入力された値で各項目を更新します。よろしいですか？',
        )
        .then(() => this.saveAiOcrResult(false));
    },
    // 排他チェック(409)で上書き確認が必要なエラーか
    isAiOcrConflict(err) {
      return (
        err?.statusCode === 409 &&
        _.some(AI_OCR_CONFLICT_FLAGS, flag =>
          _.some(
            err.response?.errors,
            error => _.get(error, `meta[${flag}]`) === false,
          ),
        )
      );
    },
    async saveAiOcrResult(overwriting) {
      this.$store.commit('START_PROCESS');

      try {
        // AI-OCR用の下書き保存BFFで保存
        await this.requestSaveDraft(overwriting);

        this.isShowDialogAiOcr = false;
        this.$store.commit('END_PROCESS');
        this.isSaveCompletedIds.push(
          this.selectedAiOcrPayload?.document?.documentManageId,
        );
        this.selectedAiOcrPayload = null;
        // 初期表示BFFを読んで値を更新
        this.refreshProcess();

        // 変更箇所のハイライト処理
        setTimeout(() => {
          this.startHighlight();
          this.$store.dispatch('SHOW_COMPLETED');
        }, 1000);
      } catch (err) {
        this.$store.commit('END_PROCESS');
        // 再送(overwriting=true)後の再409はループさせずアラートで終了
        if (!overwriting && this.isAiOcrConflict(err)) {
          // 他プロセスで更新されたフロー共通データの上書き確認
          this.$store
            .dispatch('SHOW_CONFIRM', err.message)
            .then(() => this.saveAiOcrResult(true))
            .catch(() => {});
          return;
        }
        const meta = err?.response?.errors?.[0]?.meta;
        if (Array.isArray(meta)) {
          console.error(meta);
          const messages = meta.map(m => m.validMessage + '<br>').join('');
          this.$store.dispatch('SHOW_ALERT', messages);
        } else {
          this.$store.dispatch('SHOW_ALERT', err?.message);
        }
      }
    },
    // 送信する帳票オブジェクトを調整
    rejectPostDocuments() {
      const keepKeys = [
        'documentArchiveId',
        'documentEditFlg',
        'documentComment',
        'documentLinkInv',
        'documentLinkPl',
        'documentLinkSi',
        'documentLinkAn',
        'documentLinkBl',
        'documentLinkCo',
        'documentLinkOthers1',
        'documentLinkOthers2',
        'documentLinkOthers3',
        'documentLinkOthers4',
        'documentLinkOthers5',
        'documentLinkLabelOthers1',
        'documentLinkLabelOthers2',
        'documentLinkLabelOthers3',
        'documentLinkLabelOthers4',
        'documentLinkLabelOthers5',
      ];

      const list = this.s.res.documents.map(doc => {
        return {
          ..._.pick(doc, keepKeys),
          documentEditFlg: doc.documentEditFlg
            ? doc.documentEditFlg
            : DOCUMENT_EDIT_FLG.NO_EDIT,
          documentComment: doc.documentComment ? doc.documentComment : '',
        };
      });

      return list;
    },
    async requestSaveDraft(overwriting = false) {
      if (!this.ocrApiMapping[this.processType]) {
        return Promise.reject(
          new Error(`このプロセスはAI-OCR読取結果の反映に対応していません。`)
        );
      }
      const action =
        this.s.res.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM
          ? PROCESS_OPERATION.F_SAVING
          : PROCESS_OPERATION.T_SAVING;

      // OCRが触った項目だけの疎ボディを構築する。
      // 送らないキーはBFF(postProcessWkDiff)が最新initialの値で維持するため、
      // 先行帳票で反映済みの項目が消えない。
      const diffBody = {};

      // 単一項目: 反映ダイアログの各行（手修正はtwNewValueに反映済み）
      (this.mappingRes?.tableData || []).forEach(row => {
        _.set(diffBody, row.twFieldPath, row.twNewValue);
      });

      // 明細: 今回のOCR読取が生成した配列のみ丸ごと送る（現行と同じ配列置換）。
      // 生成していない配列はキーごと省略＝BFF側で既存明細が維持される。
      // 同一配列への複数帳票書き込みの要素保持はPB-2004（BFF側）で対応。
      (this.mappingRes?.ocrTouchedArrayPaths || []).forEach(path => {
        const rows = _.get(this.mappingData, path);
        if (Array.isArray(rows) && rows.length > 0) {
          _.set(diffBody, path, _.cloneDeep(rows));
        }
      });

      // リクエストの形に調整
      const documents = this.rejectPostDocuments();

      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: this.ocrApiMapping[this.processType],
          path: {
            entityId: this.s.res.tradeManagement.entityId,
            processId: this.s.res.tradeManagement.processId,
            processSeq: parseInt(this.s.res.tradeManagement.processSeq),
          },
        },
        data: {
          aiOcrMeta: {
            documentManageId: this.selectedAiOcrPayload.document
              .documentManageId,
            documentTrx: this.selectedAiOcrPayload.documentTrx,
          },
          meta: {
            tradingId: this.s.res.tradeManagement.tradingId,
            tradingFlowId: this.s.res.tradeManagement.tradingFlowId,
            updateDate: this.s.res.tradeManagement.updateDate,
            action: action,
            companyId: this.companyId,
          },
          updateCommonItemsExclusiveFlag1: overwriting,
          updateCommonItemsEntitySpecificItemsExclusiveFlag2: overwriting,
          overwritePredecessorEntityExclusiveFlag3: overwriting,
          overwritingCommonItemsEntitySpecificItemsExclusiveFlag4: overwriting,
          ...diffBody,
          documents,
        },
      };

      try {
        const res = await $api.request(params);
        return res;
      } catch (e) {
        throw e;
      }
    },
    // AIOCRの対象項目をハイライト
    startHighlight() {
      if (this.timerId) clearTimeout(this.timerId);
      this.clearHighlight();

      // 商品項ハイライト
      const targetTitles = [];
      let goodsLineFlag = false;
      let containerSealsFlag = false;
      let goodsLinePackingFlag = false;
      // 単一項目
      this.mappingRes.tableData.map(item =>
        targetTitles.push(item.twFieldName),
      );
      // テーブル項目
      this.mappingRes.itemsTableData.map((item, index) => {
        if (item.ocrGoodsShortName) goodsLineFlag = true;
        if (item.ocrContainerSize || item.ocrContainerNo)
          containerSealsFlag = true;

        if(item.ocrPlPcsNumber || item.ocrPlQuantity1){
          goodsLinePackingFlag = true;
        }
      });
      if (goodsLineFlag) {
        if(this.processType === PROCESS_TYPE.ICREQ){
          targetTitles.push('imInvoiceDescriptionOfGoods');
        }
        if(this.processType === PROCESS_TYPE.ECREQ){
          targetTitles.push('exInvoiceDescriptionOfGoods');
        }
      }
      if (containerSealsFlag) {
        targetTitles.push('containerType');
      }
      if(goodsLinePackingFlag){
        targetTitles.push('goodsLinePacking');
      }
      document.querySelectorAll('div[title]').forEach(el => {
        if (targetTitles.includes(el.getAttribute('title'))) {
          el.classList.add('blink');
          el.style.fontWeight = 'bold';
        }
      });
      this.timerId = setTimeout(() => {
        this.clearHighlight();
      }, 60000);
    },
    clearHighlight() {
      // 初期化
      document.querySelectorAll('.blink').forEach(el => {
        el.classList.remove('blink'); // クラスを削除
        el.style.fontWeight = 'normal'; // フォントを通常に変更
      });
    },
    // 改行・タブ・null を安全な文字列に
    sanitizeForTsv(val) {
      if (val == null) return '';
      return String(val)
        .replace(/\r?\n/g, ' ') // 改行 → スペース
        .replace(/\t/g, ' '); // タブ → スペース
    },
    buildTsvFromData(data) {
      const { tableData, itemsTableData } = data;
      if (!Array.isArray(tableData) || !Array.isArray(itemsTableData)) {
        return '';
      }
      // -------------------------
      // 1. tableData ヘッダー
      // -------------------------
      const tableHeaders = tableData.map(row => row.twFieldLabel);
      const tableValues = tableData.map(row =>
        this.sanitizeForTsv(row.twNewValue),
      );
      // -------------------------
      // 2. itemsTableData が空の場合の処理
      // -------------------------
      if (itemsTableData.length === 0) {
        // tableData だけで TSV を返す（1レコードのみ）
        const headerRow = tableHeaders.join('\t');
        const valueRow = tableValues.join('\t');
        return `${headerRow}\n${valueRow}`;
      }
      // -------------------------
      // 3. itemsTableData がある場合（通常処理）
      // -------------------------
      const firstItem = itemsTableData[0];
      const itemKeys = Object.keys(firstItem);
      const itemHeaders = itemKeys.map(key => key.replace(/^ocr/, ''));
      const headerRow = [...tableHeaders, ...itemHeaders].join('\t');
      const rows = itemsTableData.map(item => {
        const itemValues = itemKeys.map(key => this.sanitizeForTsv(item[key]));
        return [...tableValues, ...itemValues].join('\t');
      });
      return [headerRow, ...rows].join('\n');
    },
  },
};
